var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "emailRecipients" + _vm.hashPanel } },
    [
      _c(
        "EmailInput",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.oneInputDisplayed,
              expression: "!oneInputDisplayed"
            }
          ],
          ref: "inputAllEmail",
          attrs: {
            label: _vm.labelAllInput,
            emailAddresses: _vm.allEmails,
            type: "all",
            shouldHideInput: _vm.allEmails.length > 0
          },
          on: { onAddTag: _vm.onAddTag, focus: _vm.onFocusInputAllEmail }
        },
        [
          _c(
            "template",
            { slot: "tags" },
            [
              _vm._l(_vm.allEmailsDisplayed, function(emailAddress) {
                return _c("CompassTagInteractive", {
                  key: emailAddress.id,
                  ref: "tagInteractive" + emailAddress.id,
                  refInFor: true,
                  attrs: {
                    size: "small",
                    color: emailAddress.isValid ? "blue" : "red",
                    modelValue: emailAddress.email,
                    valueLabel: emailAddress.email
                  },
                  on: {
                    focus: _vm.onFocusInputAllEmail,
                    "tag-remove": function($event) {
                      return _vm.onRemoveTag(emailAddress, { id: "all" })
                    }
                  }
                })
              }),
              _vm._v(" "),
              _c("CompassPlainButton", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.allEmailsDisplayed.length !== _vm.allEmails.length,
                    expression: "allEmailsDisplayed.length !== allEmails.length"
                  }
                ],
                attrs: { label: _vm.labelMoreTags, size: "small" },
                on: { click: _vm.displayAllInputs }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "actions" },
            [
              _c("CompassPlainButton", {
                attrs: {
                  label: _vm.$t.__(
                    "email.emailPanels.EmailRecipientsInputs.more_recipients_button"
                  ),
                  size: "small",
                  variant: "neutral"
                },
                on: {
                  click: function($event) {
                    return _vm.displayAllInputs(!_vm.allInputsDisplayed)
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.inputs, function(item) {
        return _c(
          "EmailInput",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.isVisible,
                expression: "item.isVisible"
              }
            ],
            key: item.id,
            ref: "emailInput" + item.id,
            refInFor: true,
            staticClass: "input-recipients",
            attrs: {
              label: _vm.getLabelEmailInput(item),
              emailAddresses: _vm.allEmails,
              type: item.id,
              isFocused: item.isFocused,
              hashPanel: _vm.hashPanel
            },
            on: {
              onAddTag: _vm.onAddTag,
              focus: function($event) {
                return _vm.onFocusInputEmail(item)
              },
              blur: function(isFilled) {
                return _vm.onBlur(isFilled, item)
              }
            }
          },
          [
            _c(
              "template",
              { slot: "tags" },
              _vm._l(_vm.emails[item.id], function(emailAddress) {
                return _c("CompassTagInteractive", {
                  key: emailAddress.id,
                  ref: "tagInteractive" + emailAddress.id,
                  refInFor: true,
                  attrs: {
                    size: "small",
                    color: emailAddress.isValid ? "blue" : "red",
                    modelValue: emailAddress.email,
                    valueLabel: emailAddress.email
                  },
                  on: {
                    "tag-remove": function($event) {
                      return _vm.onRemoveTag(emailAddress, item)
                    }
                  }
                })
              }),
              1
            ),
            _vm._v(" "),
            item.id === "to"
              ? _c(
                  "template",
                  { slot: "actions" },
                  [
                    _c("CompassPlainButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "email.emailPanels.EmailRecipientsInputs.more_recipients_button"
                        ),
                        size: "small",
                        variant: "neutral"
                      },
                      on: {
                        click: function($event) {
                          return _vm.displayAllInputs(!_vm.allInputsDisplayed)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }